import {
    Account,
    Auditable,
    FormData,
    Order,
    QueryParams,
    ShippingMethod,
    ShippingStatus,
    SortParams,
    Tissue,
} from "..";

export interface Shipment extends Auditable {
    orderId?: number;
    shippingStatusId?: number;
    shippingMethodId?: number;
    fromAccountId?: number;
    toAccountId?: number;
    shippedOn?: string;
    estimatedArrival?: string;
    arrivedOn?: string;
    trackingNumber?: string;
    comments?: string;
    packedByUserId?: number;
    receivedByUserId?: number;

    order?: Order;
    shippingStatus?: ShippingStatus;
    shippingMethod?: ShippingMethod;
    fromAccount?: Account;
    toAccount?: Account;
    tissues?: Tissue[];
    forms?: FormData[];
}

export const DefaultShipmentQueryParams: QueryParams = {};

export const DefaultShipmentSortParams: SortParams = {
    orderBy: "createdOn",
    orderDesc: "false",
};
